import * as React from "react";
import typeToReducer from "type-to-reducer";

import { SHOW_MODAL, HIDE_MODAL } from "./types";

const initialState = {
  modalType: null,
  modalProps: {},
};

export default typeToReducer(
  {
    [SHOW_MODAL]: (state, { modalType, modalProps }) => ({
      modalType,
      modalProps,
    }),
    [HIDE_MODAL]: (state, action) => ({
      ...initialState,
    }),
  },
  initialState,
);
